import { useEffect, useRef } from 'react';
import thinkingdata from 'thinkingdata-browser';
import { getCookie } from '@/utils/cookie';
import { isPC } from '@/utils';
import { useMemoizedFn } from 'ahooks';

// 创建 SDK 配置对象
export const seaTaConfig = {
  appId: 'c65ac3fd37c24b22bdc1b2eb66d3d4fa',
  serverUrl: 'https://ta-report-sea.roglobal.com',
}

export const hmtTaConfig = {
  appId: '59aeb53930314ae3a6b7db065c29c061',
  serverUrl: 'https://ta-report.123u.com',
}

export const lnaTaConfig = {
  appId: 'd24cc03bccb14899a55ade9feaf9ee45',
  serverUrl: 'https://ta-report-lna.roglobal.com',
}

const fromatQuery = () => {
  const query = decodeURIComponent(window.location.search.substring(1))
  const param: Record<string, string> = {}
  query.replace(/([^?&]+)=([^?&]+)/g, (s, v, k) => {
    param[v] = k
    return `${k}=${v}`
  })
  return param
}

const searchParams = new URLSearchParams(
  decodeURIComponent(window.location.search)
)

const getPathnameLastTwoPath = () => {
  const path = window.location.pathname
    .split('/')
    .slice(-2)
    .filter((item) => item)
    .join('/')
  return `/${path}`
}

const getClient = () => {
  let client = 'PC'
  if (!isPC()) {
    const ua = navigator.userAgent.toLocaleLowerCase()
    const isIOS = /(iphone|ipad|ipod|ios)/i.test(ua)
    if (isIOS) {
      client = 'IOS'
    } else {
      client = 'Android'
    }
  }
  return client
}

const getGclid = () => {
  return (
    searchParams.get('external_click_id') ||
    getCookie('external_click_id') ||
    getCookie('gclid') ||
    ''
  )
}

export enum EventType {
  PcDownload = 'pcDownload',
  ApkDownload = 'apkDownload',
  AppStoreDownload = 'appStoreDownload',
  GooglePlayDownload = 'googlePlayDownload',
  HuaweiDownload = 'huaweiDownload',
  // 十人本埋点
  PageOpen = 'PageOpen',
  Login = 'Login',
  TeamCreate = 'TeamCreate',
  TeamJoin = 'TeamJoin',
  TeamQuit = 'TeamQuit',
  TeamDismiss = 'TeamDismiss',
  TeamRemove = 'TeamRemove',
}

/**
 * 用于从广告落地页跳转到官网，进行数据上报
 * 跳转过来 url 携带的关键字：{lpurl}?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{matchtype}&external_click_id={gclid}
 */
const useTA = () => {
  const ta = thinkingdata;
  const configRef = useRef();

  useEffect(() => {
    if (configRef.current) {
      ta?.init(configRef.current);
    }
  }, [ta])

  const reportTrack = (
    event: string,
    btn?: string,
    extra?: Record<string, string>
  ) => {
    const btnInfo = btn ? { btnName: btn } : {}
    ta.track(event, {
      page: getPathnameLastTwoPath() ?? 'cover-page',
      env: import.meta.env.MODE,
      client: getClient(),
      gclid: getGclid(),
      ...fromatQuery(),
      ...btnInfo,
      ...extra,
    })
  }

  const reportTrackMemo = useMemoizedFn(
    (event: string, btn?: string, extra?: Record<string, string>) => {
      const btnInfo = btn ? { btnName: btn } : {}
      ta.track(event, {
        page: getPathnameLastTwoPath() ?? 'cover-page',
        env: import.meta.env.MODE,
        client: getClient(),
        gclid: getGclid(),
        ...fromatQuery(),
        ...btnInfo,
        ...extra,
      })
    }
  )

  const init = (taConfig) => {
    thinkingdata.init(taConfig);
    configRef.current = taConfig;
  };

  return {
    initTa: init, // 用配置对象初始化 SDK
    // isFromAd,
    reportTrack,
    reportTrackMemo,
  }
}

export default useTA
